import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'
import NewWhatsAppBotCard from '../../components/whatsAppBots/NewWhatsAppBotCard'
import CreateWhatsAppBotModal from './CreateWhatsAppBotModal'
import { useNavigate } from 'react-router-dom'

const CreateNewWhatsAppBot = () => {
  const [selectedBot, setSelectedBot] = useState<any[]>([])
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [newBotTemplate, setNewBotTemplate] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)
  const navigate = useNavigate()

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: '0px',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      maxWidth: '90vw',
      maxHeight: '90vh'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
      zIndex: 1000
    }
  }

  const handleBotSelection = (bot: any) => {
    setSelectedBot([bot])
  }

  useEffect(() => {
    const fetchTemplates = async () => {
      setIsLoading(true)
      try {
        const token = localStorage.getItem('auth-token')
        const response = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/getAllWhatsAppTemplate`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
        if (Array.isArray(response.data)) {
          setNewBotTemplate(response.data)
        }
      } catch (error) {
        console.error('Failed to fetch templates:', error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchTemplates()
  }, [])

  const handleNavigate = () => {
    navigate('/whatsapp-bots/all-bots')
  }

  const isCardSelected = (bot: any) => selectedBot.length > 0 && selectedBot[0]?.id === bot.id

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px);}
          to { opacity: 1; transform: translateY(0);}
        }
        @keyframes cardPulse {
          0% { box-shadow: 0 0px 16px #725efd33;}
          50% { box-shadow: 0 0px 32px #725efd77;}
          100% { box-shadow: 0 0px 16px #725efd33;}
        }
        @keyframes modalFadeIn {
          from { opacity: 0; transform: scale(0.97);}
          to { opacity: 1; transform: scale(1);}
        }

        .page-container {
          background: linear-gradient(120deg, #f3f6fb 0%, #e7eafc 100%);
          min-height: 100vh;
          padding: 2rem;
          animation: fadeInUp 0.7s;
        }
        .header-card {
          background: white;
          border-radius: 24px;
          padding: 2.7rem 2.4rem;
          margin-bottom: 2.2rem;
          box-shadow: 0 6px 44px rgba(66, 47, 161, 0.10);
          border: none;
          position: relative;
          overflow: hidden;
        }
        .header-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 5px;
          background: linear-gradient(90deg, #6951f2 0%, #7d1ae7 100%);
        }
        .header-content h1 {
          color: #261a59;
          font-size: 2.15rem;
          font-weight: 850;
          margin-bottom: 0.73rem;
          background: linear-gradient(135deg, #362f6e 30%, #6951f2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .header-content p {
          color: #635f8d;
          font-size: 1.08rem;
          margin: 0;
          line-height: 1.7;
        }
        .stats-bar {
          display: flex;
          gap: 2.3rem;
          margin-top: 1.6rem;
          padding-top: 1.3rem;
          border-top: 1px dashed #e1defc;
        }
        .stat-item {
          display: flex;
          flex-direction: column;
          gap: 0.27rem;
        }
        .stat-label {
          color: #95a4b8;
          font-size: 0.9rem;
          font-weight: 600;
        }
        .stat-value {
          color: #261a59;
          font-size: 1.44rem;
          font-weight: 800;
        }
        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.8rem 1.7rem;
          background: white;
          border: 2px solid #e8ecf4;
          border-radius: 15px;
          color: #344059;
          font-weight: 650;
          cursor: pointer;
          transition: all 0.28s;
          margin-bottom: 2.3rem;
          box-shadow: 0 3px 11px rgba(0,0,0,0.05);
        }
        .back-button:hover {
          background: #eceffd;
          border-color: #6951f2;
          color: #6951f2;
          transform: translateX(-2px) scale(1.03);
          box-shadow: 0 6px 20px rgba(66, 47, 161, 0.12);
        }
        .back-button i {
          font-size: 1.22rem;
          transition: transform 0.16s;
        }
        .back-button:hover i {
          transform: translateX(-2px) scale(1.07);
        }
        .select-template-btn {
          padding: 1rem 2.2rem;
          background: linear-gradient(95deg, #6951f2 0%, #7d1ae7 100%);
          color: white;
          border: none;
          border-radius: 14px;
          font-weight: 700;
          font-size: 1.02rem;
          cursor: pointer;
          transition: all 0.17s;
          box-shadow: 0 6px 26px rgba(79, 70, 229, 0.25);
          position: relative;
          overflow: hidden;
          letter-spacing: 0.5px;
        }
        .select-template-btn:hover {
          background: linear-gradient(95deg, #7d1ae7 0%, #6951f2 100%);
          box-shadow: 0 12px 32px #6951f255, 0 0px 10px #7d1ae77d;
          transform: translateY(-2px) scale(1.04);
        }
        .templates-container {
          background: white;
          border-radius: 21px;
          padding: 2.4rem;
          box-shadow: 0 5px 22px rgba(66,47,161,0.06);
          border: none;
        }
        .templates-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 3rem;
          margin-top: 1.7rem;
        }
        .bot-card {
          background: linear-gradient(135deg,#f4f7fc 70%,#ebe3fc 100%);
          border-radius: 17px;
          box-shadow: 0 2px 15px #6951f210;
          transition: box-shadow 0.21s, transform 0.21s, filter 0.17s, opacity 0.21s;
          opacity: 1;
          z-index: 1;
          min-width: 240px;
          max-width: 1fr;
          cursor: pointer;
          outline: none;
          animation: fadeInUp 0.45s;
        }
        .bot-card:not(.focused):hover {
          box-shadow: 0 8px 32px #6951f244;
          border: 1.7px solid #7d1ae7;
          transform: scale(1.035) translateY(-2px);
          opacity: 1;
        }
        .bot-card.focused {
          box-shadow: 0 18px 56px #6951f299, 0 0px 12px #7d1ae7bb;
          border: 0.4px #7d1ae7;
          transform: scale(1.07);
          opacity: 1;
          z-index: 10;
          filter: none;
          animation: cardPulse 1.25s infinite;
        }
        .bot-card.background {
          opacity: 0.79;    /* Subtle dim, not harsh */
          filter: none;     /* No blur or grayscale for approachability */
          transform: scale(0.98);
        }
        @media (max-width: 1200px) {
          .templates-grid {
            gap: 1.1rem;
            justify-content: flex-start;
          }
          .bot-card { min-width: 180px;}
        }
        @media (max-width: 992px) {
          .templates-grid { gap: .73rem;}
          .bot-card { min-width: 130px;}
        }
        @media (max-width: 768px) {
          .page-container { padding: 1rem;}
          .header-card { padding: 1rem;}
          .header-content h1 { font-size: 1.24rem;}
          .templates-grid { flex-direction: column;}
        }
        .loading-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 5rem 2rem;
          gap: 1.6rem;
        }
        .loading-spinner {
          width: 64px;
          height: 64px;
          border: 4.5px solid #e3e7fa;
          border-top: 4.5px solid #6951f2;
          border-radius: 50%;
          animation: spin 1.0s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg);} }
        .loading-text {
          color: #6951f2;
          font-size: 1.2rem;
          font-weight: 600;
        }
        .empty-state {
          text-align: center;
          padding: 5rem 2rem;
        }
        .empty-state-icon {
          width: 124px;
          height: 124px;
          margin: 0 auto 1.6rem;
          background: linear-gradient(135deg,#ece9fa 0%,#f6f3ff 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3.3rem;
          color: #a3a1c7;
        }
      `}</style>
      <div className='page-container'>
        <button className='back-button' onClick={handleNavigate}>
          <i className='bi bi-arrow-left'></i>
          <span>Back to All Bots</span>
        </button>
        <div className='header-card'>
          <div className='d-flex justify-content-between align-items-start flex-wrap gap-3'>
            <div className='header-content'>
              <h1>Choose Your WhatsApp Bot Template</h1>
              <p>
                Get started quickly with ready templates designed for different use cases!
                <br />
                You can customize each template to match your needs.
              </p>
              <div className='stats-bar'>
                <div className='stat-item'>
                  <span className='stat-label'>Available Templates</span>
                  <span className='stat-value'>{newBotTemplate.length}</span>
                </div>
                {selectedBot.length > 0 && (
                  <div className='stat-item'>
                    <span className='stat-label'>Selected</span>
                    <span className='stat-value' style={{ color: '#7d1ae7' }}>
                      {selectedBot[0].templateName || 'Template'}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className='d-flex align-items-center'>
              {selectedBot.length > 0 && (
                <button
                  className='select-template-btn btn btn-gradient'
                  onClick={openModal}
                  type='button'
                >
                  Continue with template
                  <i className='bi bi-arrow-right ms-2 text-white'></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className='templates-container'>
          {isLoading ? (
            <div className='loading-container'>
              <div className='loading-spinner'></div>
              <p className='loading-text'>Loading templates...</p>
            </div>
          ) : newBotTemplate.length > 0 ? (
            <div className='templates-grid'>
              {newBotTemplate.map((bot: any, index: number) => (
                <div
                  key={bot.id || index}
                  className={
                    'bot-card shadow-sm ' +
                    (isCardSelected(bot) ? 'focused' : selectedBot.length > 0 ? 'background' : '')
                  }
                  tabIndex={0}
                  role='button'
                  onClick={() => handleBotSelection(bot)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleBotSelection(bot)
                  }}
                  aria-label={bot.templateName || 'Bot Template Card'}
                  style={{
                    position: 'relative',
                    outline: isCardSelected(bot) ? '2px solid #7d1ae7' : ''
                  }}
                >
                  <NewWhatsAppBotCard
                    to='#'
                    name={bot.templateName || 'Car Dealership Bot'}
                    description={
                      bot.description ||
                      'Deploy Car Dealership Bot on car dealership website to interact with visitors ...'
                    }
                    imageLink={
                      bot.imageLink ||
                      'https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/whatsapp.jpeg'
                    }
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className='empty-state'>
              <div className='empty-state-icon'>
                <i className='bi bi-inbox'></i>
              </div>
              <h3>No Templates Available</h3>
              <p>
                We couldn't find any bot templates at the moment. Please check back later or contact
                support.
              </p>
            </div>
          )}
        </div>
        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={customModalStyles}
          contentLabel='Create WhatsApp Bot'
          appElement={document.getElementById('root') || undefined}
        >
          <CreateWhatsAppBotModal closeModal={closeModal} selectedBot={selectedBot} />
        </ReactModal>
      </div>
    </>
  )
}

export default CreateNewWhatsAppBot
